module.exports = __webpack_public_path__ + "img/banking.ee59a7bd.svg";